export default __webpack_public_path__ + "static/media/fog.a88ffd1b.svg";